import React, { useMemo } from 'react';
import { mdiFileDocumentOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { renderDate, Variables } from '../../../..';
import { ClaimDataJsonTree } from './claim-data-json-tree';
import * as Cd from './claim-data-detail.styles';
import { IClaimDataDetailProps } from './claim-data-detail.types';
import { buildClaimDataPanelViewModel } from './claim-data-detail.utils';

export const ClaimDataEmbeddedPanel: React.FunctionComponent<IClaimDataDetailProps> = ({
    claimData,
    embedded = true,
    num,
    label,
}) => {
    const viewModel = useMemo(
        () => buildClaimDataPanelViewModel(claimData, { num, label }),
        [claimData, num, label],
    );

    const providerLabel =
        viewModel.providerCount === 1
            ? '1 provider'
            : `${viewModel.providerCount} providers`;
    const serviceLabel =
        viewModel.serviceCount === 1
            ? '1 service'
            : `${viewModel.serviceCount} services`;

    return (
        <Cd.CdPanel $embedded={embedded}>
            <Cd.CdSectionCard $embedded={embedded}>
                <Cd.CdHeaderRow>
                    <Cd.CdIconWrap>
                        <Icon path={mdiFileDocumentOutline} size={0.83} color={Variables.ThemeLight.TextMedium} />
                    </Cd.CdIconWrap>
                    <Cd.CdHeaderMain>
                        <Cd.CdTitle>{viewModel.label}</Cd.CdTitle>
                        <Cd.CdSubtitle>
                            {viewModel.claimKindLabel} · <strong>{serviceLabel}</strong> · {providerLabel} · received
                            from <Cd.CdMuted>{viewModel.sourceLabel}</Cd.CdMuted>
                        </Cd.CdSubtitle>
                    </Cd.CdHeaderMain>
                </Cd.CdHeaderRow>

                <Cd.CdFactsGrid>
                    <Cd.CdFactCell $span={2}>
                        <Cd.CdFactLabel>ID</Cd.CdFactLabel>
                        <Cd.CdFactValue>{viewModel.id || '—'}</Cd.CdFactValue>
                    </Cd.CdFactCell>
                    <Cd.CdFactCell>
                        <Cd.CdFactLabel>Control Number</Cd.CdFactLabel>
                        <Cd.CdFactValue>{viewModel.controlNumber || '—'}</Cd.CdFactValue>
                    </Cd.CdFactCell>
                    <Cd.CdFactCell>
                        <Cd.CdFactLabel>Type</Cd.CdFactLabel>
                        {viewModel.type ? <Cd.CdTypePill>{viewModel.type}</Cd.CdTypePill> : <Cd.CdFactValue>—</Cd.CdFactValue>}
                    </Cd.CdFactCell>
                    <Cd.CdFactCell>
                        <Cd.CdFactLabel>Created</Cd.CdFactLabel>
                        <Cd.CdFactValue>
                            {viewModel.created ? renderDate(viewModel.created) : '—'}
                        </Cd.CdFactValue>
                    </Cd.CdFactCell>
                </Cd.CdFactsGrid>
            </Cd.CdSectionCard>

            <Cd.CdTreeCard $embedded={embedded}>
                <ClaimDataJsonTree payload={viewModel.payload} embedded={embedded} />
            </Cd.CdTreeCard>
        </Cd.CdPanel>
    );
};
